import { FC, useEffect, useState } from 'react';
import { Outlet, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../auth/useAuth';
import { Seo } from '../../components/common/Seo';
import * as Icon from '../../components/icons';

interface DashboardLayoutProps {}

const DashboardLayout: FC<DashboardLayoutProps> = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const searchQueryParams = useSearchParams()[0];
  const { user } = useAuth();

  const [isTabContentHeightShort, setIsTabContentHeightShort] = useState<boolean>(false);

  const activeTabClasses =
    'text-blue-primary font-semibold md:bg-[#FFF6EB] md:border-r-4 md:border-r-orange-primary max-md:border-b-4 max-md:border-b-orange-primary';

  const menuItems = [
    {
      name: 'Authentification',
      link: '/dashboard/authentication',
    },
    {
      name: 'Mes applications',
      link: '/dashboard/apps',
    },
    {
      name: 'Connexions API',
      link: '/dashboard/api-connections',
    },
  ];

  useEffect(() => {
    (async () => {
      const projectLogoSrc = searchQueryParams.get('projectLogoSrc');
      const projectName = searchQueryParams.get('projectName');
      localStorage.setItem('projectLogoSrc', projectLogoSrc ? projectLogoSrc : '');
      localStorage.setItem('projectName', projectName ? projectName : '');

      if (window.innerHeight > document.documentElement.offsetHeight) {
        setIsTabContentHeightShort(true);
      } else {
        setIsTabContentHeightShort(false);
      }

      const mailUpdatedToken = searchQueryParams.get('mailUpdatedToken');
      if (mailUpdatedToken) {
        navigate(`/dashboard/authentication`);
      }
    })();
  }, []);

  return (
    <>
      <div>
        <div>
          <div className='my-5 flex items-center max-md:justify-center md:h-7.5 md:justify-between'>
            <span className='max-md:ml-0 md:ml-10'>
              <Icon.Skezi size={1.5} />
            </span>
            <span className='mr-6 flex max-md:hidden'>
              <span className='text-gray-primary text-[0.75rem]'>{user?.email}</span>
            </span>
            <span
              className='absolute right-1 mr-5 flex cursor-pointer items-center hover:font-medium hover:underline md:hidden'
              onClick={() => {
                navigate(`/logout`);
              }}
            >
              <Icon.Logout className='mr-3' />
            </span>
          </div>
        </div>
        <div className='flex max-md:flex-col'>
          <div className='relative max-md:flex md:w-72 md:pt-20'>
            {menuItems.map((item, i) => (
              <div
                key={i}
                className={`m-auto py-5 max-md:mb-3 max-md:w-[33.33%] max-md:text-center max-md:text-sm md:pl-5 ${location.pathname.includes(item.link) ? activeTabClasses : 'cursor-pointer text-[#90ABBD]'} `}
                onClick={() => navigate(item.link)}
              >
                {item.name}
              </div>
            ))}
            <div
              className='absolute bottom-8 flex w-full cursor-pointer justify-center hover:font-medium hover:underline max-md:hidden'
              onClick={() => {
                navigate(`/logout`);
              }}
            >
              <Icon.Logout className='mr-3' />
              <span>Se déconnecter</span>
            </div>
          </div>
          <div
            className={`bg-white-light rounded-l-3xl p-7 ${isTabContentHeightShort && 'max-md:min-h-screen md:min-h-[calc(100vh-70px)]'} md:w-full`}
          >
            {location.pathname.includes('/dashboard/authentication/') && (
              <div className='mb-7 flex cursor-pointer max-md:hidden' onClick={() => navigate(`/dashboard/authentication`)}>
                <Icon.ArrowCircleLeft className='mr-3' /> <span className='text-[#7988A2]'>Authentification</span>
              </div>
            )}
            <Outlet />
          </div>
        </div>
      </div>
      <Seo title={'Dashboard'} />
    </>
  );
};

export default DashboardLayout;
